(ns practitest.frontend.components2.dashboard.charts.pie
  (:require [practitest.frontend.components2.dashboard.charts.pie-render :as render]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.pie :as transforms]
            [re-frame.core :as rf]
            ["d3" :as d3]))

;; ============================================================================
;; Configuration
;; ============================================================================
;; All magic numbers in one place for easy tuning.
;; These values control the chart's appearance and proportions.

(def chart-config
  { ;; --- SVG viewBox coordinate space (not visual size, that's in CSS) ---
   :width  400
   :height 400

   ;; --- Radius ---
   ;; Controls pie size: 0.0 to 1.0 (1.0 = fills available space)
   :radius-multiplier 0.55

   ;; --- Polyline ---
   ;; Where connector lines begin (multiplier of radius)
   :polyline-start-multiplier 0.95

   ;; --- Label Ring ---
   ;; Invisible circle where labels are initially placed before the force
   ;; simulation runs. Each label starts at its slice's mid-angle, projected
   ;; outward to this ring. The simulation then resolves collisions while
   ;; pulling labels back toward these initial positions.
   ;; Value is a multiplier of pie radius, e.g. 1.45 = 45% beyond pie edge.
   :label-ring-multiplier 1.45

   ;; --- Label Collision (rectangular) ---
   ;; Minimum spacing between label bounding boxes (viewBox units)
   :label-collide-x 100 ;; horizontal
   :label-collide-y 20  ;; vertical

   ;; --- Angle Alignment ---
   ;; How strongly labels are pulled toward their slice's angle (weak)
   :angle-strength 0.75

   ;; --- Force Simulation ---
   :force-iterations 300

   ;; --- Styling ---
   ;; Visual styles (font-size, stroke, colors) are in charts.scss
   :hover-offset    3
   :pad-angle       0.02
   ;; Shifts the chart group upward to make room for the legend below
   :center-y-offset 10
   ;; Extra space for labels beyond the viewport edge (viewBox units)
   :label-padding   45
   ;; --- 3D Edge ---
   ;; Stacked layers create a gradient rim for depth effect.
   ;; edge-depth scales dy/darken/radius-extra (1.0 = full, 0 = flat)
   :edge-depth  0.7
   :edge-layers [{:dx 0 :dy 1 :darken 0.1 :radius-extra 1}
                 {:dx 0 :dy 2 :darken 0.25 :radius-extra 2}
                 {:dx 0 :dy 3 :darken 0.5 :radius-extra 3}]

   ;; --- Animation ---
   :animation-duration  400 ;; slice grow duration on first render (ms)
   :transition-duration 600 ;; update transition duration (ms)
   :fade-duration       300 ;; polyline/label fade-in duration (ms)
   :fade-delay          400 ;; delay before polylines/labels appear (ms)
   :enter-ease          d3/easeCubicOut})


(defmethod p/render! ::chart/pie [chart ctx svg-element]
  (let [nav-evt #(rf/dispatch [::events/navigate chart %])
        ctx     (merge chart-config ctx {:on-slice-click nav-evt})]
    (render/render-chart! svg-element chart ctx)))

(defmethod p/svg-for-export ::chart/pie [_chart svg-element]
  (render/svg-for-export svg-element))

(defmethod p/transform-data ::chart/pie [chart]
  (transforms/transform chart))
